<template>
  <div>
    <van-image width="100%" height="100%" :src="imgUrl" />
  </div>
</template>
<script>
export default {
  name: "Introduce",
  data: function() {
    return {
      imgUrl: require("../../assets/introduce/introduce.png")
    };
  }
};
</script>